import classNames from 'classnames';
import AnimatedImage from 'core-lib/components/AnimatedImage';
import ShimmerImage from 'core-lib/components/ShimmerImage';
import { useComponentInViewport } from 'core-lib/hooks/useComponentInViewport';
import formatCurrency from 'core-lib/utils/currency';
import { formatFuelBalance } from 'core-lib/utils/fuel';
import { useEffect, useRef } from 'react';
import { trackProductViewedStoreV2 } from 'src/modules/parkplusStoreV2/utils/events';
import { Typography } from 'ui-v2/components/Typography';
import Product from '../../../types/product';
import s from './NewLaunchCard.module.scss';

type NewLaunchCardType = {
  data: Product;
  id: string;
  index?: number;
  title?: string;
};
export const NewLaunchCard = ({
  data,
  index,
  id,
  title,
}: NewLaunchCardType) => {
  const rootRef = useRef<HTMLDivElement>();
  const productRef = useRef(false);
  const inViewPort = useComponentInViewport(rootRef, {
    threshold: 0.5,
  });

  useEffect(() => {
    if (inViewPort && !productRef.current) {
      trackProductViewedStoreV2(title, data?.productId, {
        description: data?.eventType,
      });
      productRef.current = true;
    }
  }, [inViewPort, data?.productId, title, data?.eventType]);

  return (
    <div
      key={data?.productId}
      className={s.root}
      id={id}
      data-index={index}
      ref={rootRef}
    >
      <ShimmerImage src={data?.coverImage} className={s.coverImage} />
      <div className={s.text}>
        <Typography
          label={data?.title}
          className={s.lineClamp}
          variant="label_3_medium"
          color="primary"
        />
        <div className={s.money}>
          <Typography
            label={formatCurrency(data?.loyaltyPrice)}
            variant="label_3_bold"
            color="primary"
          />
          <Typography
            label={formatCurrency(data?.price)}
            variant="label_3_regular"
            className={s.lineThrough}
            color="tertiary"
          />
        </div>
        {data?.loyaltyPoints > 0 && data?.loyaltyPrice >= 0 && (
          <div className={classNames(s.mlPrice, s.linePriceClamp)}>
            <Typography
              label={`using `}
              color="offer"
              variant="label_4_bold"
            />
            <AnimatedImage
              src="https://parkplus-bkt-img.parkplus.io/production/team/public/FS_20240104160730062768.png"
              className={s.drop}
            />
            <Typography
              label={formatFuelBalance(data?.loyaltyPoints)}
              color="offer"
              variant="label_4_bold"
            />
          </div>
        )}
      </div>
    </div>
  );
};
